// extracted by mini-css-extract-plugin
module.exports = {"klarna-placement":"_2Cs1E","klarnaPlacement":"_2Cs1E"};